/**
 * API 常量配置
 */

// API 基础 URL
export const BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://54.222.231.142:5888'

// 请求超时时间（毫秒）
export const REQUEST_TIMEOUT = 30000

// HTTP 状态码
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504
}

// 业务状态码
export const BUSINESS_CODE = {
  SUCCESS: 0,
  TOKEN_EXPIRED: 10001,
  TOKEN_INVALID: 10002,
  REFRESH_TOKEN_EXPIRED: 10003
}

// 错误消息
export const ERROR_MESSAGE = {
  NETWORK_ERROR: '网络连接失败，请检查网络设置',
  TIMEOUT_ERROR: '请求超时，请稍后重试',
  SERVER_ERROR: '服务器错误，请稍后重试',
  UNAUTHORIZED: '用户未认证或认证已过期',
  FORBIDDEN: '权限不足，无法访问该资源',
  NOT_FOUND: '请求的资源不存在'
}

// 本地存储 Key
export const STORAGE_KEY = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info'
}

// 请求重试配置
export const RETRY_CONFIG = {
  MAX_RETRIES: 3, // 最大重试次数
  RETRY_DELAY: 1000, // 重试延迟（毫秒）
  RETRY_STATUS_CODES: [408, 429, 500, 502, 503, 504] // 需要重试的状态码
}

// user role
export const USER_ROLE = {
  IDENTITY_CUSTOMER: 'IDENTITY_CUSTOMER',
  IDENTITY_ADMIN: 'IDENTITY_ADMIN',
}

export const WS_EVENTS = {
  PING: 'ping',
  PONG: 'pong'
}